import { useState } from "react";
import { faqs } from "@/mocks/comicData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="你关心的都在这里"
          title="常见问题"
          subtitle="关于排行榜更新、独家汉化、完结漫画与免费追更的常见疑问，一次为你解答。"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((f) => {
            const active = openId === f.id;
            return (
              <div
                key={f.id}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <button
                  onClick={() => setOpenId(active ? null : f.id)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-bold text-foreground-900 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      active ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {active && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}